module.exports = __webpack_public_path__ + "img/laundryBag.5f5f78d8.jpg";